// removed by extract-text-webpack-plugin
module.exports = {"deck-navigator":"_200CEQJi9ErEMuwva1dBE9","remove-comment":"_1BiMmFuHtZGCUU8K3105PO","left":"_3QAzQNAeFluoWkpYqsyxTv","right":"_3Jen8dlJJ8zM13ajvtwlgJ","deck-nav-controls":"_10tcDR26IFc9vdKNaJav6y","button":"_3CD5IYV6uEudX0HYF7UsMK","deck-nav-links":"_3t2YzHxjgpj_-YOHv9S5-K","deck-nav-count":"_30ekc4cmi2CFd2FBOq8OMz"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/DeckNavigator.styl
// module id = 588
// module chunks = 0